var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdepirce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "white",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67898 10C7.75151 10 7 10.7584 7 11.6943V24.3057C7 25.2416 7.75151 26 8.67898 26H27.321C28.2485 26 29 25.2416 29 24.3057V11.6943C29 10.7584 28.2485 10 27.321 10H8.67898ZM14.9201 24.223H8.75621V22.4453H13.1592V20.6682H10.5178V18.8912H14.9201V24.223ZM27.2384 24.223H16.6817V22.4453H25.4775V20.6682H22.8623V18.8912H27.2384V24.223ZM21.0745 18.8912V20.6682H16.6985V18.8858H18.46V18.8912H21.0745ZM21.0799 11.777H25.4822V13.554H22.8408V15.3311H27.2438V17.1088H21.0799V11.777ZM14.9255 11.777H17.54V11.7716H19.3015V13.554H14.9255V11.777ZM8.76158 11.777H13.1377V13.554H10.5225V15.3311H19.3183V17.1088H8.76158V11.777Z",
    fill: "url(#paint0_linear_870_1780)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_870_1780",
    x1: 18,
    y1: 10,
    x2: 18,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89542"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdepirce);
export default __webpack_public_path__ + "static/media/edepirce.d646c964.svg";
export { ForwardRef as ReactComponent };